import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { formatCrypto, formatCurrencies } from 'shared/utils';
import { WithdrawSingleCurrencyCryptoSummaryDto } from 'app/interfaces/dto';
import { useStyles } from '../TransactionSummary.styles';
import { FormatCurrencies } from 'shared/components/Format/Currency';
import { SystemCurrency } from '@okletsplay/core';

interface SummaryProps {
  summary: WithdrawSingleCurrencyCryptoSummaryDto;
}

// TODO: OKLP-1988 Cleanup this component.
export const WithdrawSingleCurrencyCryptoSummary: FC<SummaryProps> = ({ summary }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.row}>
        <Typography>Crypto to Crypto Transfer</Typography>
      </Box>
      <Box className={classes.row}>
        <Typography>Withdraw Amount</Typography>
        <Typography>
          {formatCurrencies(summary.sourceAmountCrypto, summary.sourceAmountFiat)}
        </Typography>
      </Box>
      <Box className={classes.row}>
        <Typography>Processing Fee</Typography>
        <Typography>{formatCrypto(summary.feeCrypto)}</Typography>
      </Box>
      <Box className={classes.row}>
        <Typography>Destination Amount</Typography>
        <Typography>
          {formatCrypto(summary.destinationAmountCrypto, SystemCurrency.OKLP)}
        </Typography>
      </Box>
      <Box className={classes.row}>
        <Typography>New Balance</Typography>
        <FormatCurrencies amount={summary.newBalanceCrypto} currency={SystemCurrency.OKLP} />
      </Box>
    </Box>
  );
};
